import { connect } from 'react-redux';
import AddCustomExclusionDialog from '../../components/shared_policies/AddCustomExclusionDialog';

import {
  addCustomExclusion,
  closeExclusionModal,
} from '../../actions/shared_policies';

const mapStateToProps = state => {
  return {
    showCustomExclusion: state.shared_policies.showExclusionModal,
  };
};

const mapDispatchToProps = dispatch => ({
  addCustomExclusion: (type, value) => {
    dispatch(addCustomExclusion(type, value));
  },
  closePopUp: () => {
    dispatch(closeExclusionModal());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCustomExclusionDialog);
